// User achievements and badges tracking

export const trackAction = (action) => {
  const stats = getStats();
  
  switch(action) {
    case 'route_created':
      stats.routesCreated = (stats.routesCreated || 0) + 1;
      break;
    case 'vote_given':
      stats.votesGiven = (stats.votesGiven || 0) + 1;
      break;
    case 'comment_posted':
      stats.commentsPosted = (stats.commentsPosted || 0) + 1;
      break;
    default:
      break;
  }
  
  localStorage.setItem('routevote_stats', JSON.stringify(stats));
  return stats;
};

export const getStats = () => {
  const stored = localStorage.getItem('routevote_stats');
  return stored ? JSON.parse(stored) : {
    routesCreated: 0,
    votesGiven: 0,
    commentsPosted: 0
  };
};

export const getBadges = () => {
  const stats = getStats();
  const badges = [];
  
  if (stats.routesCreated >= 1) badges.push({ icon: '🛫', name: 'First Route', desc: 'Suggested your first route' });
  if (stats.routesCreated >= 10) badges.push({ icon: '✈️', name: 'Route Pioneer', desc: 'Suggested 10 routes' });
  if (stats.routesCreated >= 50) badges.push({ icon: '🌍', name: 'Global Planner', desc: 'Suggested 50 routes' });
  
  if (stats.votesGiven >= 10) badges.push({ icon: '🗳️', name: 'Voter', desc: 'Voted 10 times' });
  if (stats.votesGiven >= 100) badges.push({ icon: '⭐', name: 'Super Voter', desc: 'Voted 100 times' });
  
  if (stats.commentsPosted >= 5) badges.push({ icon: '💬', name: 'Discusser', desc: 'Posted 5 comments' });
  if (stats.commentsPosted >= 50) badges.push({ icon: '🎤', name: 'Community Voice', desc: 'Posted 50 comments' });
  
  return badges;
};

export const getNextBadge = () => {
  const stats = getStats();
  
  // Find the closest next badge
  const targets = [
    { threshold: 1, stat: 'routesCreated', name: 'First Route' },
    { threshold: 10, stat: 'routesCreated', name: 'Route Pioneer' },
    { threshold: 10, stat: 'votesGiven', name: 'Voter' },
    { threshold: 5, stat: 'commentsPosted', name: 'Discusser' },
  ];
  
  for (const target of targets) {
    if (stats[target.stat] < target.threshold) {
      return {
        name: target.name,
        progress: stats[target.stat],
        target: target.threshold,
        stat: target.stat
      };
    }
  }
  
  return null;
};
